import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { GetSplitMyPartyAccInfo } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import LineBtn from "../../../Button/LineBtn";
import DotStatus from "../../../DefaultStyles/DotStatus";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { recentChatBtnClick } from "../ChatInfo/ChatSearch/ChatSearchResult";
import { chatTabState } from "../ChatInfo/ChatTab";
import { IPartyDetailMemberInfo, OldMemberTag } from "./PartyDetailMemberInfo";
import Flex from "../../../DefaultStyles/Flex";
import dayjs from "dayjs";
import AgreeHistoryBtn from "./PartyDetailMemberInfo/AgreeHistoryBtn";
import LinkidEmailItem from "./PartyDetailMemberInfo/LinkidEmailItem";
import { partyCommentDataState } from "./PartyDetailComment";
import { uplusInfoFilterState } from "../../../../pages/Party/UplusMatchingInfo";
import {
  getMyPartyStatusText,
  getPartyRegState,
} from "../../../../AdminApi/commFunc";
import AlertModal from "../../../Modal/AlertModal";
import { decryptPW } from "../../../../ApiTS/ApiCommonTS";
import {
  getShareDefData,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import MacroStateModal from "./MacroStateModal/MacroStateModal";
import { secodaryMailConverter } from "../../../../scCommon/scCommonFunc";
import NetflixExtraAccModal from "./NetflixExtraAccModal/NetflixExtraAccModal";
import NetflixExtraPwRegisterModal from "./NetflixExtraPwRegisterModal/NetflixExtraPwRegisterModal";
import NetflixExtraPwResetModal from "./NetflixExtraPwResetModal/NetflixExtraPwResetModal";
import InviteLinkModal from "./InviteLinkModal/InviteLinkModal";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../AdminApi/3.0_utils";
import AlimTalkModal from "../../AlimTalk/AlimTalkModal";
import LmsModal from "../../Message/LmsModal";
import { getYTStateString } from "../../../../pages/Party/YoutubeMatchingInfo";

interface PartyDetailMemberHistoryProps {
  partyId?: string;
  subsId: number;
  data?: {
    owner?: string;
    servsubsid?: number;
    startdate?: string;
    enddate?: string;
    partyid?: string;
    maxmemb?: number;
    members?: number;
    state?: number;
    mystate: number;
    ownerPayday?: number;
  };
  ownerId: number;
  saveExMember: (memberData: IPartyDetailMemberInfo[]) => void;
}

export const exMemberListState = atom<IPartyDetailMemberInfo[]>({
  key: "exMemberListState",
  default: [],
});

export default function PartyDetailMemberHistory({
  partyId,
  data,
  ownerId,
  subsId,
  saveExMember,
}: PartyDetailMemberHistoryProps) {
  const navigate = useNavigate();
  const auth = useRecoilValue(authType);
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);
  const partyCommentData = useRecoilValue(partyCommentDataState);
  const setUplusInfoFilter = useSetRecoilState(uplusInfoFilterState);

  const subsData = GetSubscriptionSetData_V3(subsId ?? 0);
  const shareDefData = subsData
    ? getShareDefData(subsData?.SHARDEF_ID!, 0)
    : undefined;
  const isOpenID = shareDefData?.SHARDEF_TYP?.includes("open");
  const isInviteMail = shareDefData?.SHARDEF_TYP === "invite_mail";
  const isSecondaryMail = shareDefData?.SHARDEF_TYP === "invite_2ndry";
  const isRegisterId = shareDefData?.SHARDEF_TYP === "register_id";
  const isInviteExtra =
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP === "invite_extra" ||
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP ===
      "invite_lkdextra";
  const isInviteLink =
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP === "invite_link";
  const isUplus = subsData?.SVC_ID === 90000;

  const isInviteLkdMail =
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP === "invite_lkdmail";

  const [page, setPage] = useState(0);
  const [exMemberList, setExMemberList] = useRecoilState(exMemberListState);
  const [netflixExtraPwModal, setNetflixExtraPwModal] = useState({
    modal: false,
    pw: "",
  });
  const [macroStateModal, setMacroStateModal] = useState({
    modal: false,
    uid: 0,
    nickname: "",
    name: "",
    macro: 0,
  });
  const [netflixExtraAccModal, setNetflixExtraAccModal] = useState({
    modal: false,
    pw: "",
    uid: 0,
    email: "",
    nickname: "",
    name: "",
    linkidmail: "",
  });
  const [netflixExtraPwResetModal, setNetflixExtraPwResetModal] = useState({
    modal: false,
    uid: 0,
  });
  const [netflixExtraPwRegistModal, setNetflixExtraPwRegistModal] = useState({
    modal: false,
  });

  const [RejoinConfirmModal, setRejoinConfirmModal] = useState({
    uid: 0,
    visible: false,
  });
  const [RejoinConfirmBtnClick, setRejoinConfirmBtnClick] = useState(false);

  const [getPassword, setGetPassword] = useState(false);
  const [inviteLinkModal, setInviteLinkModal] = useState({
    modal: false,
    uid: 0,
  });
  const [account, setAcount] = useState("");
  const [viewData, setViewData] = useState({
    user: "",
    template: "",
    subsData: "",
    partyId: "",
    grade: 0,
  });
  const [sendTalkModal, setSendTalkModal] = useState(false);
  const [sendLmsModal, setSendLmsModal] = useState(false);

  const { response, fetchData } = useApi({
    method: "get",
    url:
      auth?.partyInfo && subsData
        ? isUplus
          ? `uplus2/${partyId}/users/1?page=${page}&size=10`
          : `party/${partyId}/users/1?page=${page}&size=5`
        : undefined,
  });

  const { response: pwRes } = useApi({
    method: "get",
    url:
      getPassword && netflixExtraAccModal.uid > 0
        ? `party/${partyId}/extraPw/${netflixExtraAccModal.uid}?email=${netflixExtraAccModal.email}`
        : undefined,
  });

  // 재가입 허용하기
  const { response: rejoin } = useApi({
    method: "post",
    url: RejoinConfirmBtnClick
      ? `party/${partyId}/reJoinUser/${RejoinConfirmModal?.uid}`
      : undefined,
  });

  const hasRealName = Boolean(
    shareDefData?.LDR_NM || getShareDefData(subsData?.SHARDEF_ID!, 1)?.MBR_NM,
  );
  const hasProfileName = Boolean(
    shareDefData?.LDR_SVCNM ||
    getShareDefData(subsData?.SHARDEF_ID!, 1)?.MBR_SVCNM,
  );

  const hasProfileNumber = subsData?.SVC_ID === 3100;
  const isTvingAdd = subsData?.SVC_ID === 410;
  const isYoutubeW = subsData?.SVC_ID === 3800;
  const isYoutube = subsData?.SVC_ID === 3700;
  const isGPTSolo = subsData?.SVC_ID === 2850;

  const flexibleHeader = [
    isInviteMail ? "링키드 이메일" : isSecondaryMail ? "신메일" : undefined,
    (isRegisterId || isInviteMail) && !isYoutubeW ? "등록 이메일" : undefined,
    isInviteExtra || isInviteLkdMail || isTvingAdd ? "계정 정보" : undefined,
    isInviteLink ? "초대 링크" : undefined,
    isOpenID || isYoutube || isGPTSolo ? undefined : "등록 상태",
    isInviteExtra ? "매크로 상태" : undefined,
    hasProfileNumber ? "사용 프로필" : undefined,
    hasProfileName && !hasProfileNumber ? "프로필 이름" : undefined,
    hasRealName ? "실명" : undefined,
    isRegisterId || isInviteMail ? "정보 변경 일시" : undefined,
    isGPTSolo || isYoutube ? "접수 상태" : undefined,
  ];

  const uplusFlexibleHeader = [
    "휴대폰 번호",
    "이름",
    "생년월일",
    "결합 코드",
    "상세",
  ];

  const partyInfoHeader = [
    "UID_이름_닉네임",
    ...(isUplus ? uplusFlexibleHeader : flexibleHeader),
    "상태",
    "가입일",
    "종료일",
    "동의 내역",
    "채팅",
    "알림톡",
    "LMS",
    "가입이력말소",
  ];

  useEffect(() => {
    if (response?.status === 200) {
      setExMemberList(response?.data?.items);
      saveExMember(response?.data?.items);
    }
  }, [response]);

  useEffect(() => {
    if (rejoin?.status === 200) {
      setExMemberList(response?.data?.items);
      saveExMember(response?.data?.items);
    }
  }, [rejoin]);

  useEffect(() => {}, [exMemberList]);

  useEffect(() => {
    if (pwRes?.status === 200) {
      setNetflixExtraAccModal((prev) => ({
        ...prev,
        ...(pwRes?.data?.email && pwRes?.data?.email?.length
          ? { email: pwRes?.data?.email }
          : {}),
        ...(pwRes?.data?.pw && pwRes?.data?.pw?.length
          ? {
              pw: decryptPW(
                pwRes?.data?.pw,
                netflixExtraAccModal.uid,
              )?.replaceAll('"', ""),
            }
          : {}),
      }));

      setGetPassword(false);
    }
  }, [pwRes]);

  return (
    <>
      <Table tableHeadData={partyInfoHeader} tableMinWidth={950}>
        <>
          {exMemberList?.map((d: IPartyDetailMemberInfo) => {
            const account =
              GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id === "" ||
              !GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id
                ? secodaryMailConverter(ownerId, subsData?.SVC_ID, d?.pindex)
                : GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id;

            return (
              <TableBody key={d?.uid}>
                <TableBodyItem>
                  <Flex gapSize={6}>
                    <Text onClick={() => navigate(`/users/info/${d?.uid}`)}>
                      {d?.uid}_{d?.name}_{d?.nickname}
                    </Text>

                    <>
                      {d?.grade === 0 ? (
                        <PartyOwnerTag>파티장</PartyOwnerTag>
                      ) : d?.isOld === 1 ? (
                        <OldMemberTag>연장</OldMemberTag>
                      ) : null}
                    </>
                  </Flex>
                </TableBodyItem>
                
                <>
                  {isUplus ? (
                    <>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_phone ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_name ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_birth ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_code ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem>
                        <LineBtn
                          btnText="보기"
                          btnClickEvent={() => {
                            setUplusInfoFilter((prev) => ({
                              ...prev,
                              searchType: "uid",
                              searchValue: d?.uid,
                            }));
                            navigate(`/party/uplus`);
                          }}
                          disabled={!(d?.uid && +d?.uid > 0)}
                        />
                      </TableBodyItem>
                    </>
                  ) : (
                    <>
                      {isOpenID || isYoutube || isGPTSolo ? null : (
                        <>
                          {/* 링키드 이메일 */}
                          {isInviteMail || isSecondaryMail ? (
                            <LinkidEmailItem
                              partyId={partyId}
                              subsId={subsId}
                              d={d}
                            />
                          ) : null}

                          {/* 계정 정보 */}
                          {(isInviteExtra || isInviteLkdMail || isTvingAdd) && (
                            <TableBodyItem>
                              <LineBtn
                                btnText={"보기"}
                                disabled={d?.grade !== 1 ? true : false}
                                btnClickEvent={() => {
                                  setNetflixExtraAccModal((prev) => ({
                                    ...prev,
                                    modal: true,
                                    pw: "",
                                    uid: +d?.uid,
                                    nickname: d?.nickname,
                                    name: d?.name,
                                    extrainfo: d?.extrainfo!,
                                    email: account,
                                    linkidmail: d?.linkidmail!,
                                  }));
                                  setGetPassword(true);
                                }}
                              />
                            </TableBodyItem>
                          )}

                          {/* 초대 링크 */}
                          {isInviteLink && (
                            <TableBodyItem>
                              <LineBtn
                                btnText={"보기"}
                                disabled={
                                  d?.grade !== 1 || d?.needreg !== 0
                                    ? true
                                    : false
                                }
                                btnClickEvent={() =>
                                  setInviteLinkModal({
                                    uid: +d?.uid,
                                    modal: true,
                                  })
                                }
                              />
                            </TableBodyItem>
                          )}

                          {/* 비밀번호 */}
                          {isSecondaryMail ? (
                            <TableBodyItem>
                              <LineBtn
                                btnText="보기"
                                disabled={
                                  d?.grade !== 1 ||
                                  !d?.extrainfo?.includes("netfPw")
                                }
                                btnClickEvent={() => {
                                  const hasPw =
                                    d?.extrainfo?.includes("netfPw");

                                  if (!hasPw) return;

                                  const extrainfoParsed = JSON.parse(
                                    d?.extrainfo ?? "{}",
                                  );
                                  let pwValue_origin = "";
                                  let pwValue = "";

                                  if (hasPw) {
                                    pwValue_origin = extrainfoParsed?.netfPw;
                                    pwValue =
                                      decryptPW(pwValue_origin, +d?.uid) ?? "";
                                  }

                                  console.log(pwValue);

                                  setNetflixExtraPwModal({
                                    modal: true,
                                    pw: pwValue,
                                  });
                                }}
                              />
                            </TableBodyItem>
                          ) : undefined}

                          {/* 등록 이메일 */}
                          {(isRegisterId || isInviteMail) && !isYoutubeW ? (
                            <TableBodyItem>
                              {GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id ===
                              ""
                                ? "-"
                                : (GetSplitMyPartyAccInfo(d?.shareid ?? "")
                                    ?.id ?? "-")}
                            </TableBodyItem>
                          ) : null}

                          {/* 등록 상태 */}
                          <TableBodyItem>
                            {getPartyRegState(d?.grade, d?.needreg!, d?.macro)}
                          </TableBodyItem>

                          {/* 매크로 상태 */}
                          {isInviteExtra ? (
                            <TableBodyItem>
                              <LineBtn
                                btnText="보기"
                                disabled={!d?.macro || d?.macro === 0}
                                btnClickEvent={() =>
                                  setMacroStateModal({
                                    modal: true,
                                    macro: d?.macro ?? 0,
                                    name: d?.name,
                                    nickname: d?.nickname,
                                    uid: +d?.uid,
                                  })
                                }
                              />
                            </TableBodyItem>
                          ) : null}

                          {/* 프로필 이름 */}
                          {hasProfileName ? (
                            <TableBodyItem>
                              {GetSplitMyPartyAccInfo(d?.shareid ?? "")
                                ?.profileName !== ""
                                ? GetSplitMyPartyAccInfo(d?.shareid ?? "")
                                    ?.profileName
                                : "-"}
                            </TableBodyItem>
                          ) : null}

                          {/* 실명 */}
                          {hasRealName ? (
                            <TableBodyItem>
                              {d?.extrainfo
                                ? (JSON.parse(d?.extrainfo)?.name ?? "-")
                                : "-"}
                            </TableBodyItem>
                          ) : null}

                          {/* 정보 변경 시간 */}
                          {!(
                            isOpenID ||
                            isSecondaryMail ||
                            isInviteExtra ||
                            isInviteLink ||
                            isInviteLkdMail
                          ) ? (
                            <TableBodyItem>
                              {d?.shareinfoUpdate
                                ? dayjs(d?.shareinfoUpdate)?.format(
                                    "YYYY-MM-DD HH:mm",
                                  )
                                : "-"}
                            </TableBodyItem>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>

                {/* 프로필 번호 */}
                {hasProfileNumber ? (
                  <TableBodyItem>
                    {d?.pindex ? d?.pindex : "-"} 번
                  </TableBodyItem>
                ) : null}

                {/* 접수 상태 */}
                {d?.extrainfo && (isGPTSolo || isYoutube) ? (
                  <TableBodyItem>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "16px",
                          fontSize: "13px",
                          fontWeight: 600,
                          backgroundColor:
                            JSON.parse(d?.extrainfo)?.ytstate === 1
                              ? "#FFF3E0"
                              : JSON.parse(d?.extrainfo)?.ytstate === 2
                                ? "#E3F2FD"
                                : JSON.parse(d?.extrainfo)?.ytstate === 3
                                  ? "#E8F5E9"
                                  : JSON.parse(d?.extrainfo)?.ytstate === 4 ||
                                      JSON.parse(d?.extrainfo)?.ytstate === 5
                                    ? "#FFEBEE"
                                    : "#F5F5F5",
                          color:
                            JSON.parse(d?.extrainfo)?.ytstate === 1
                              ? "#E65100"
                              : JSON.parse(d?.extrainfo)?.ytstate === 2
                                ? "#1565C0"
                                : JSON.parse(d?.extrainfo)?.ytstate === 3
                                  ? "#2E7D32"
                                  : JSON.parse(d?.extrainfo)?.ytstate === 4 ||
                                      JSON.parse(d?.extrainfo)?.ytstate === 5
                                    ? "#C62828"
                                    : "#616161",
                        }}
                      >
                        {JSON.parse(d?.extrainfo)?.ytstate
                          ? getYTStateString(
                              JSON.parse(d?.extrainfo)?.ytstate ?? "-",
                            )
                          : "-"}
                      </span>
                    </div>
                  </TableBodyItem>
                ) : null}

                {/* 상태 */}
                <TableBodyItem>
                  <DotStatus
                    text={getMyPartyStatusText(d?.mystate).text}
                    color={getMyPartyStatusText(d?.mystate).color}
                    size="sm"
                  />
                </TableBodyItem>
                {/* 가입일 */}
                <TableBodyItem>{d?.joindate}</TableBodyItem>
                {/* 종료일 */}
                <TableBodyItem>
                  {d?.exit
                    ? d.ishide === 1 || d?.mstate === 100
                      ? dayjs(d?.exit)?.add(-1, "day")?.format("YYYY-MM-DD")
                      : d?.exit
                    : "-"}
                </TableBodyItem>
                {/* 동의 내역 */}
                <TableBodyItem>
                  <AgreeHistoryBtn d={d} data={data} />
                </TableBodyItem>
                {/* 채팅 */}
                <TableBodyItem>
                  <LineBtn
                    icon="chat"
                    btnClickEvent={() => {
                      setTab(1);
                      setRecentBtnClick(true);

                      navigate({
                        pathname: `/party/chat`,
                        search: `${partyId}@${ownerId}@${d?.uid}`,
                      });
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.chat || d?.grade === 0}
                  />
                </TableBodyItem>
                {/* 알림톡 보내기 */}
                <TableBodyItem>
                  <LineBtn
                    icon="send"
                    btnClickEvent={() => {
                      setAcount(account);
                      setViewData({
                        ...viewData,
                        user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                        subsData: `${subsId}_${getString3ByKey(
                          GetSubscriptionSetData_V3(subsId)?.SUBS_NM ?? 0,
                        )}`,
                        partyId: partyId!,
                        grade: d?.grade,
                      });

                      setSendTalkModal(true);
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.kakao}
                  />
                </TableBodyItem>

                {/* LMS 보내기 */}
                <TableBodyItem>
                  <LineBtn
                    icon="mail"
                    btnClickEvent={() => {
                      setViewData({
                        ...viewData,
                        user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                        subsData: `${subsId}_${getSubsNameBySubsId3(subsId)}`,
                      });

                      setSendLmsModal(true);
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.kakao}
                  />
                </TableBodyItem>

                {/* 가입 기록 말소하기 */}
                <TableBodyItem>
                  <LineBtn
                    icon="person_remove"
                    btnClickEvent={() => {
                      setRejoinConfirmModal({
                        uid: Number(d?.uid),
                        visible: true,
                      });
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.kakao}
                  />
                </TableBodyItem>
              </TableBody>
            );
          })}
        </>
      </Table>

      <Pagination
        totalPage={response?.status === 200 ? response?.data?.totalPage : 3}
        currentPage={page}
        pageClickEvent={(index) => setPage(index)}
      />

      {netflixExtraPwModal.modal && (
        <AlertModal
          title={"비밀번호"}
          desc={netflixExtraPwModal.pw?.replaceAll('"', "") ?? ""}
          customCancelBtn={<></>}
          confirmText="확인"
          btnColor="mint"
          confirmEvent={() =>
            setNetflixExtraPwModal({
              modal: false,
              pw: "",
            })
          }
        />
      )}

      {/* 매크로 상태 보기 */}
      {macroStateModal.modal && (
        <MacroStateModal
          userData={{
            uid: macroStateModal.uid,
            nickname: macroStateModal.nickname,
            name: macroStateModal.name,
          }}
          macro={macroStateModal.macro}
          closeEvent={() =>
            setMacroStateModal({
              modal: false,
              macro: 0,
              name: "",
              nickname: "",
              uid: 0,
            })
          }
          isExitMember
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/1?page=${page}&size=10`
                    : `party/${partyId}/users/1?page=${page}&size=5`
                  : undefined,
            })
          }
        />
      )}

      {/* 넷플릭스 추가공유 비밀번호 보기 */}
      {netflixExtraAccModal.modal && (
        <NetflixExtraAccModal
          closeEvent={() =>
            setNetflixExtraAccModal({
              ...netflixExtraAccModal,
              modal: false,
            })
          }
          resetEvent={() =>
            setNetflixExtraPwResetModal({
              modal: true,
              uid: netflixExtraAccModal?.uid,
            })
          }
          registEvent={() =>
            setNetflixExtraPwRegistModal((prev) => ({
              ...prev,
              modal: true,
            }))
          }
          userData={{
            uid: netflixExtraAccModal.uid,
            name: netflixExtraAccModal.name,
            nickname: netflixExtraAccModal.nickname,
          }}
          accData={{
            email: netflixExtraAccModal.email,
            pw: netflixExtraAccModal.pw,
          }}
          svcid={subsData?.SVC_ID!}
        />
      )}

      {/* 넷플릭스 추가공유 비밀번호 설정 모달 */}
      {netflixExtraPwResetModal.modal && (
        <NetflixExtraPwResetModal
          partyId={+partyId!}
          uid={netflixExtraAccModal.uid}
          closeEvent={() =>
            setNetflixExtraPwResetModal((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          email={netflixExtraAccModal.email}
          linkidmail={netflixExtraAccModal.linkidmail}
        />
      )}

      {/* 넷플릭스 추가공유 비밀번호 등록 모달 */}
      {netflixExtraPwRegistModal.modal && (
        <NetflixExtraPwRegisterModal
          partyId={+partyId!}
          uid={netflixExtraAccModal.uid}
          closeEvent={() =>
            setNetflixExtraPwRegistModal((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/1?page=0&size=5`
                    : `party/${partyId}/users/1?page=0&size=100`
                  : undefined,
            })
          }
          email={netflixExtraAccModal.email}
          linkidmail={netflixExtraAccModal.linkidmail}
        />
      )}

      {inviteLinkModal.modal && (
        <InviteLinkModal
          uid={inviteLinkModal.uid}
          closeEvent={() => setInviteLinkModal({ uid: 0, modal: false })}
        />
      )}

      {/* 알림톡 보내기 모달 */}
      {sendTalkModal && (
        <AlimTalkModal
          closeEvent={() => setSendTalkModal(false)}
          type="input"
          viewData={viewData}
          userAccount={account}
        />
      )}
      {/* lms 보내기 모달 */}
      {sendLmsModal && (
        <LmsModal
          closeEvent={() => setSendLmsModal(false)}
          type="input"
          viewData={viewData}
        />
      )}

      {/* 재가입 허용 모달 */}
      {RejoinConfirmModal.visible && (
        <AlertModal
          title="가입 이력을 말소하겠습니까?"
          desc="재가입이 가능해 집니다."
          cancelEvent={() =>
            setRejoinConfirmModal({
              uid: 0,
              visible: false,
            })
          }
          confirmText="이력 말소"
          confirmEvent={() => {
            setRejoinConfirmBtnClick(true);
          }}
          btnColor="mint"
        />
      )}
    </>
  );
}

export const PartyOwnerTag = styled.label`
  margin-left: 6px;
  padding: 4px 6px;
  min-height: 23px;
  border-radius: 3px;
  background-color: #f5f5f5;
  word-break: keep-all;

  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.buttonColor.blueNormal};
`;

const Text = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;
